import React from "react";
import { useTheme } from "@mui/material/styles";
import { TextField, InputAdornment, Box } from "@mui/material";

const IconInputField = ({
  value,
  onChange,
  placeholder = "",
  disabled = false,
  startIcon = null,
  endIcon = null,
  type = "text",
  fullWidth = true,
  size = "small",
  error = false,
  helperText,
  height = "30px",
  sx = {},
  inputProps = {},
  ...rest
}) => {
  const theme = useTheme();

  const renderIcon = (icon) => {
    if (!icon) return null;
    if (React.isValidElement(icon)) {
      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            color: theme.palette.primary.greyPrimary,
            "& svg": {
              fontSize: "18px",
              width: "18px",
              height: "18px",
            },
          }}
        >
          {icon}
        </Box>
      );
    }
    return null;
  };

  return (
    <TextField
      fullWidth={fullWidth}
      size={size}
      type={type}
      placeholder={placeholder}
      value={value ?? ""}
      onChange={onChange}
      disabled={disabled}
      error={error}
      helperText={helperText}
      autoComplete="off"
      InputProps={{
        ...(startIcon && {
          startAdornment: (
            <InputAdornment position="start" sx={{ mr: 0.5 }}>
              {renderIcon(startIcon)}
            </InputAdornment>
          ),
        }),
        ...(endIcon && {
          endAdornment: (
            <InputAdornment position="end" sx={{ ml: 0.5 }}>
              {renderIcon(endIcon)}
            </InputAdornment>
          ),
        }),
      }}
      inputProps={inputProps}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: theme.shape?.customBorderRadius?.[1] || "4px",
          height: height,
          color: theme.palette.primary.greyPrimary,
          fontSize: theme.typography.customFontSize[2],
          paddingLeft: startIcon ? "10px" : "14px",
          "& .MuiInputAdornment-root svg": {
            fontSize: "18px",
            width: "18px",
            height: "18px",
            color: theme.palette.primary.greyPrimary,
            transition: "color 0.2s ease-in-out",
          },
          "&:hover .MuiInputAdornment-root svg": {
            color: theme.palette.primary.mainHover,
          },
          "&.Mui-focused .MuiInputAdornment-root svg": {
            color: theme.palette.primary.main,
          },
          "& fieldset": {
            borderWidth: "1px",
            borderColor: error
              ? theme.palette.primary.redPrimary
              : theme.palette.primary.borderGreyPrimary,
          },
          "&:hover fieldset": {
            borderWidth: "1px",
            borderColor: error
              ? theme.palette.primary.redPrimary
              : theme.palette.primary.mainHover,
          },
          "&.Mui-focused fieldset": {
            borderWidth: "1px",
            borderColor: error
              ? theme.palette.primary.redPrimary
              : theme.palette.primary.main,
          },
        },
        ...sx,
      }}
      {...rest}
    />
  );
};

export default IconInputField;
